module.exports = {"20x30": __webpack_public_path__ + "images/satellite-2-debris-big-1-30x20.png"};